// 服务类型底价策略 — 公共常量与取值工具
// 服务类型来源：套餐管理 → 服务类型（同一服务类型可在国内、海外同时售卖）
// TODO: 联调时替换为接口数据（GET 服务类型列表）

export const MOCK_SERVICE_TYPES = [
  { serviceId: '300010', serviceName: '全天云存', categoryName: '云端存储' },
  { serviceId: '300011', serviceName: '事件云存', categoryName: '云端存储' },
  { serviceId: '300036', serviceName: '逗留提醒', categoryName: 'AI识别' },
  { serviceId: '300033', serviceName: '人脸识别', categoryName: 'AI识别' },
  { serviceId: '300031', serviceName: '短信服务', categoryName: '通信服务' },
  { serviceId: '400001', serviceName: 'AI家庭看护', categoryName: 'AI智能体' },
];

export const REGION_OPTIONS = [
  { label: '国内（CNY）', value: 'cn' },
  { label: '海外（USD）', value: 'os' },
];

export const REGION_LABEL = { cn: '国内', os: '海外' };

export const formatDiscount = (ratio) => {
  if (ratio == null) return '不打折';
  if (Number(ratio) === 0) return '0.00%（等同不扣）';
  if (Number(ratio) >= 100) return '不打折';
  return `${Number(ratio).toFixed(2)}%`;
};

export const formatBasePrice = (policy) => {
  if (!policy || !policy.isDeductBasePrice) return '不扣除';
  return `扣除 / ${formatDiscount(policy.discountRatio)}`;
};

// 逐层取值：serviceOverrides[serviceId] → fallback（上一层整体策略）
export const resolveServicePolicy = (serviceOverrides, fallback, serviceId) => {
  const own = serviceOverrides?.[serviceId];
  if (own) return { policy: own, source: 'override' };
  return { policy: fallback, source: 'inherit' };
};

export const countOverrides = (serviceOverrides) => Object.keys(serviceOverrides || {}).length;
